<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							
							<!-- <div style="width: 150px;" class="ml-1">
								<v-text-field clearable dense label="学员学号" outlined v-model="query.studentNo" >
								</v-text-field>
							</div> -->
							
							<div style="width: 120px;" class="ml-1">
								<v-text-field clearable dense label="学员姓名" outlined v-model="query.studentName">
								</v-text-field>
							</div>
							<div style="width: 150px;" class="ml-1">
								<v-text-field clearable dense label="手机号" outlined v-model="query.mobile" >
								</v-text-field>
							</div>
							<div style="width: 150px;" class="ml-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined ></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="ml-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 140px;" class="ml-1">
								<v-select :items="queryStatusItems" v-model="query.status" item-text="name" item-value="id"
									label="学员状态" dense outlined></v-select>
							</div>
							<div style="width: 120px;" class="ml-1">
								<v-select :items="joinClassItems" v-model="query.isJoinClass" item-text="name" item-value="id"
									label="是否分班" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="info" class="ml-1">查询</v-btn>
							<v-btn @click="exportExcel" color="info" class="ml-1">导出</v-btn>
						</v-col>
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-3">
							<v-btn @click="showAddDialog" small color="info">添加新学员</v-btn>
							<v-btn @click="importStudent.show=true" small color="info" class="ml-2">批量导入学员</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				
				<!-- 表格内容区 -->
				<template v-slot:body="{ items }">
					<tbody>
					  <tr v-for="(item,index) in items" :key="item.id" :class="index % 2 == 0?'tr_one':'tr_two'">
						<td>{{ item.studentNo }}</td>
						<td>{{ item.studentName }}</td>
						<td>
							<v-avatar rounded class="my-1">
								<a @click="viewStudentDetail(item)"><v-img v-if="item.avatar" :src="imgPrev + item.avatar + imgSize50" width="50" height="50"></v-img></a>
							</v-avatar>
						</td>
						<td>{{ item.sourceName }}</td>
						<td>
							<v-chip small :color="genderColor(item.gender)">{{ genderName(item.gender) }}
							</v-chip>
						</td>
						<td>{{ item.age }}</td>
			
						<td>{{item.contactorCall}} {{item.contactorMobile}}</td>
						<td>
							<span v-if="item.classCount > 0">{{ joinClassName(item.classCount) }}</span>
							<span v-if="item.classCount == 0" style="color:#F50057">{{ joinClassName(item.classCount) }}</span>
						</td>
						<td>{{studentStatusName(item.status)}}</td>
						<td>
							<span v-if="item.appUserMobile">{{ item.appUserMobile }}</span>
							<div v-if="!item.appUserMobile" class="d-flex" >
								<v-btn small @click="showParent(item)" color="info" class="ml-1">去绑定</v-btn>
							</div>
						</td>
						<td>{{item.createAt}}</td>
						<td align="center">
							<v-btn color="info" @click="viewStudentDetail(item)" small class="mr-1">学员详情</v-btn>
						</td>
					  </tr>
					</tbody>
				</template>
			
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 学员详情组件 -->
		<studentDetail :show="studentDetail.dialog" :studentId="studentDetail.studentId" 
			@cancel="studentDetailCanceled" ></studentDetail>
		
		<!-- 绑定家长手机号组件 -->
		<bindParentMobile :show="bindParent.show" :studentId="bindParent.studentId" :studentName="bindParent.studentName" 
			@cancel="bindParent.show=false" @success="bindParentSuccess"></bindParentMobile>
		
		<!-- 添加学员组件	 -->
		<createStudent :show="add.dialog" @cancel="add.dialog=false" @success="createStudentSuccess"></createStudent>
		<!-- 导入学员组件	 -->
		<importStudent :show="importStudent.show" @cancel="importStudent.show=false" @success="importStudentSuccess" @toResult="toResultPage"></importStudent>
	</v-card>
</template>

<script>
	import * as XLSX from "xlsx";
	import global from '../../../config/global'
	import utils from '../../../config/utils'
	import studentDetail from "../../../components/student_detail.vue"
	import bindParentMobile from "../../../components/bind_parent_mobile.vue"
	import createStudent from "../../../components/create_student.vue"
	import importStudent from "../../../components/import_student.vue"
	export default {
		name: "student-list",
		components:{studentDetail,bindParentMobile,createStudent,importStudent},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				currentShopId:"",
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '学员管理',
						disabled: true
					},
				],
				imgPrev: global.config.imgPre,
				imgSize50:global.config.imgSize50,
				data: {
					total: 0,
					headers: [
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '头像',
							value: 'avatar',
							sortable: false
						},
						{
							text: '生源类型',
							value: 'sourceName',
							sortable: false
						},
						{
							text: '性别',
							value: 'gender',
							sortable: false
						},
						{
							text: '年龄',
							value: 'age',
							sortable: false
						},
						{
							text: '联系人信息',
							value: 'contactorInfo',
							sortable: false
						},
						
						{
							text: '是否分班',
							value: 'classCount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '家长登录手机',
							value: 'appUserMobile',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				search: "",
				selectShopList: [], //选择门店数据源
				joinClassItems:[{id: "",name: "全部"},{id: "1",name: "已分班"},{id: "0",name: "未分班"}],
				queryStatusItems: [{
					id: "",
					name: "全部"
				}, {
					id: "1",
					name: "正式学员"
				}, {
					id: "2",
					name: "结业学员"
				}, {
					id: "3",
					name: "意向学员"
				}, {
					id: "4",
					name: "无意向"
				}],
				statusItems: [{
					id: "1",
					name: "正式学员"
				}, {
					id: "3",
					name: "意向学员"
				}],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					studentName: "",
					studentNo: "",
					status: "1",
					isJoinClass:"",
					mobile:""
				},
				
				add: {
					dialog: false,
				},
				bindParent: {
					show: false,
					studentId: "",
					studentName: "",
				},
				studentDetail:{
					dialog:false,
					studentId:""
				},
				importStudent:{
					show:false
				}
				
			}
		},
		created() {
			// 设置当前校区ID
			this.currentShopId = utils.getCurrentShopId();
			
			// 接收传入的是否加入班级参数
			let isJoinClass = this.$route.query.isJoinClass;
			if (isJoinClass){
				this.query.isJoinClass = isJoinClass;
			}
			
			console.log("isJoinClass",isJoinClass);
			
			
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showParent(item) {
				this.bindParent.show = true;
				this.bindParent.studentId = item.id;
				this.bindParent.studentName = item.studentName;
			},
			createStudentSuccess(){
				this.add.dialog=false;
				this.getTableDataList();
			},
			importStudentSuccess(){
				this.importStudent.show = false;
				this.getTableDataList();
			},
			showAddDialog() {
				this.add.dialog = true;
			},
			exportExcel() {
				const that = this;
				this.query.loading = true;
				
				let url = `/edu/student/export?v=1`;
				if (this.currentShopId) {
					url += "&shopId=" +this.currentShopId;
				}
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.mobile) {
					url += "&mobile=" + this.query.mobile;
				}
				
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				if (this.query.isJoinClass) {
					url += "&isJoinClass=" + this.query.isJoinClass;
				}
				
				
				this.axios.get(url).then(response => {
				
					console.log(response);
				
					if (response.data["code"] === 200) {
						let exportArr = response.data["data"] ? response.data["data"] : [];
						
						const fdArray = [];
						exportArr.forEach(function(data, index) {
							var obj = {
								序号: index + 1,
								学号: data.studentNo,
								姓名: data.studentName,
								年龄:  data.age,
								性别: data.genderName,
								生源类型:data.sourceName,
								联系人称呼:data.contactorCall,
								联系人手机: data.contactorMobile,
								就读学校: data.fromSchoolName,
								居住片区: data.fromRegionName,
								家庭住址: data.homeAddress
							};
							fdArray.push(obj);
						});
						// 新建一个excel.xlsx
						var wb = XLSX.utils.book_new();
						//封装JSON 数据
						var fdXslxws = XLSX.utils.json_to_sheet(fdArray);
						XLSX.utils.book_append_sheet(wb, fdXslxws, "sheet");
						XLSX.writeFile(wb, "学员导出列表" + ".xlsx");
		
						that.query.loading = false;
						
						that.$noty.success("导出成功");
					}else {
						that.query.loading = false;
						that.$noty.error("获取失败：" + response.data["message"]);
					}
					
				})
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				let url = `/edu/student/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.currentShopId) {
					url += "&shopId=" +this.currentShopId;
				}
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.mobile) {
					url += "&mobile=" + this.query.mobile;
				}

				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				if (this.query.isJoinClass) {
					url += "&isJoinClass=" + this.query.isJoinClass;
				}
				
				console.log(url);

				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}else if (response.data["code"] === 7031){
						// 调整到登录页
						that.$router.push('/login');
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			genderName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "男生";
				} else if (state === "0") {
					stName = "女生";
				}
				return stName;
			},
			genderColor(state) {
				let color = "";
				if (state === "1") {
					color = "blue lighten-4";
				} else if (state === "0") {
					color = "pink lighten-4";
				}

				return color;
			},
			joinClassColor(classCount){
				const count = parseInt(classCount);
				let color = "";
				if (count > 0) {
					color = "success";
				} else if (count === 0) {
					color = "error";
				}
				return color;
			},
			joinClassName(classCount){
				const count = parseInt(classCount);
				let stName = "未知";
				if (count > 0) {
					stName = "已分班";
				} else if (count === 0) {
					stName = "未分班";
				}
				return stName;
			},
			studentStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "在读";
				} else if (state === "0") {
					stName = "冻结";
				} else if (state === "2") {
					stName = "结业";
				} else if (state === "3") {
					stName = "意向";
				} else if (state === "4") {
					stName = "无意向";
				}
				return stName;
			},
			studentStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				} else if (state === "2") {
					color = "primary";
				} else if (state === "3") {
					color = "warning";
				} else if (state === "4") {
					color = "error";
				}

				return color;
			},
			viewStudentDetail(item){
				// 显示用户详情
				console.log(item);
				this.studentDetail.dialog = true;
				this.studentDetail.studentId = item.id;
			},
			studentDetailCanceled(){
				this.studentDetail.dialog = false;
				//this.getTableDataList();
			},
			bindParentSuccess(){
				this.bindParent.show=false;
				this.getTableDataList();
			},
			toResultPage(e){
				console.log("e",e);
				// this.$router.push({
				// 	path: `/edu/import/student/result/${this.shopId}/${e.batchNo}`
				// })
				
				this.$router.push(`/edu/import/student/result/${e.batchNo}`);
			}
		}
	}
</script>

<style scoped lang="scss">
	
</style>
